import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-infoobservaciones',
  templateUrl: './infoobservaciones.component.html',
  styleUrls: ['./infoobservaciones.component.scss']
})
export class InfoobservacionesComponent implements OnInit {
  @Input() dataObservciones:any;
  constructor() { }

  ngOnInit() {
  }

}
